import { Controller } from "stimulus";
import Cookies from "js-cookie";

export default class extends Controller {
  static values = {
    prefectureId: Number,
    cityId: Number
  };

  connect() {
    this.setAreaCookie();
  }

  setAreaCookie() {
    if (!this.prefectureIdValue) {
      return;
    }

    const areaData = {
      prefecture_id: this.prefectureIdValue,
      city_id: this.cityIdValue || null
    };

    try {
      Cookies.set('last_viewed_area', JSON.stringify(areaData), {
        expires: 30,
        secure: true,
        sameSite: 'Strict'
      });
    } catch (error) {
      console.warn('エリア情報のCookie設定に失敗しました:', error);
    }
  }

  static getLastViewedArea() {
    try {
      const cookieValue = Cookies.get('last_viewed_area');
      if (!cookieValue) {
        return null;
      }

      const areaData = JSON.parse(cookieValue);

      if (!areaData.prefecture_id || !Number.isInteger(areaData.prefecture_id)) {
        return null;
      }

      return {
        prefecture_id: areaData.prefecture_id,
        city_id: areaData.city_id || null
      };
    } catch (error) {
      console.warn('エリア情報のCookie読み取りに失敗しました:', error);
      return null;
    }
  }
}
